import type { Locale, Security } from "~types/types";

type SnapshotApiRequest = {
    ticker: string;
    duration?: string;
    startDate?: string;
    endDate?: string;
    locale?: Locale;
};

export async function fetchSnapshotFromApi({
    ticker,
    duration,
    startDate,
    endDate,
    locale = "en",
}: SnapshotApiRequest) {
    const snapshotResponse = await fetch(
        `/lineup-next/api/snapshot?ticker=${ticker}${
            duration ? `&presetDuration=${duration}` : ""
        }${startDate ? `&snapshotStartDate=${startDate}` : ""}${
            endDate ? `&snapshotEndDate=${endDate}` : ""
        }${`&locale=${locale}`}`
    );

    if (!snapshotResponse.ok) {
        throw new Error(
            `Error when fetching from api/snapshot: ${snapshotResponse.text()}`
        );
    }

    return (await snapshotResponse.json()) as Security[];
}
